import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'redaction'
import cx from 'classnames'

import Button from 'components/_new/Button/Button'
import Text from 'components/_new/typography/Text/Text'

import messages from './messages'
import s from './UpgradeButton.scss'

import iconUpgrade from './images/icon-upgrade-white.svg'
import iconUpgradeBlack from './images/icon-upgrade-black.svg'


const UpgradeButton = (props) => {
  const { className, id, onClick, disabled, color, size, fullWidth, isVisible, dataTestId } = props

  const title   = messages.newTitle
  const iconSrc = disabled ? iconUpgradeBlack : iconUpgrade
  const sm      = size === 'sm'

  const iconClassName = cx({
    [s.icon]: !sm,
    [s.smIcon]: sm,
    [s.disabled]: disabled,
  })

  return Boolean(isVisible) && (
    <Button
      className={className}
      id={id}
      size={size}
      color={color}
      disabled={disabled}
      fullWidth={fullWidth}
      weight="medium"
      uppercase
      dataTestId={dataTestId}
      onClick={onClick}
    >
      <img className={iconClassName} src={iconSrc} alt="icon" draggable={false} />
      <Text className={s.title} message={title} size={sm ? '14-24' : undefined} />
    </Button>
  )
}

UpgradeButton.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  fullWidth: PropTypes.bool,
  dataTestId: PropTypes.string,
  onClick: PropTypes.func.isRequired,
}

UpgradeButton.defaultProps = {
  color: 'brand',
  size: 'md',
}


export default connect({
  isVisible: 'models.subscription.isUpgradable',
})(UpgradeButton)
